<div *ngIf="searching" class="spinner-wrapper">
  <div class="clock-spinner">
    <span class="sr-only">Loading...</span>
  </div>
</div>

<div *ngIf="!searching && !!searchText && searchText != '' && getNumResults() === 0" class="gray4 pl-5 pt-3">
  No results for '{{ searchText }}'
</div>

<div class="search-results" *ngFor="let category of searchResultCategories">
  <!-- category header -->
  <app-section-header *ngIf="!!searchResults[category] && searchResults[category].length > 0" [title]="category" classes="background-light general-light-bg"></app-section-header>

  <!-- category results -->
  <div  *ngIf="!!searchResults[category] && searchResults[category].length > 0">
    <div [hidden]="searching" *ngFor="let result of searchResults[category]"
         class="search-result row general-dark2-bg mx-0 my-1 d-md-flex justify-content-between cursor-pointer position-relative"
         [routerLink]="result.link">
      <div class="hover-border position-absolute d-none"></div>

      <div class="d-none d-md-block col-xs-4 col-md-4 col-lg-3 col-xl-2 px-4 py-2 result-image-col">
        <div class="result-image h-100 aspect-ratio-vert-box-4-3 p-0 d-md-block" defaultImage="/assets/images/blur.jpg" lazyLoad="{{ !!result.image ? result.image : null }}"></div>
      </div>
      <div class="col-xs-8 col-md-6 col-lg-7 col-xl-8 p-4 result-content-col">
        <div class="row">
          <div class="col general-white h4 result-title"  [innerHTML]="result.title | html"></div>
        </div>
        <div class="col gray2 body result-description" [innerHTML]="result.description | html"></div>
        <div class="row">
        </div>
      </div>
      <div class="d-none d-md-block col-xs-0 col-md-2 col-lg-2 col-xl-2 px-4 result-link-col">
        <span class="cream go-link">Go <i class='fas fa-arrow-right'></i></span>
      </div>
    </div>
  </div>
</div>
